import { QuarterDay, ScheduleFrequency } from "../../../types/scheduled_reports";

export const DAYS_OF_MONTH = [
  {
    label: "Last day of the month",
    value: "-1",
  },
].concat(
  Array.from({ length: 31 }, (_, i) => ({
    label: String(i + 1),
    value: String(i + 1),
  }))
);

export const QUARTER_FREQUENCY_OPTIONS = [
  { label: "First day of quarter", value: QuarterDay.FIRST },
  { label: "Middle of quarter", value: QuarterDay.MIDDLE },
  { label: "Last day of quarter", value: QuarterDay.LAST },
];

export const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
].map((day) => ({ label: day, value: day.toUpperCase() }));

export const FREQUENCY_OPTIONS = [
  { label: "Daily", value: ScheduleFrequency.DAY },
  { label: "Weekly", value: ScheduleFrequency.WEEK },
  {
    label: "Bi-Weekly (once every 2 weeks)",
    value: ScheduleFrequency.TWOWEEK,
  },
  { label: "Monthly", value: ScheduleFrequency.MONTH },
  { label: "Quarterly", value: ScheduleFrequency.QUARTER },
];
